import { TFunction } from 'i18next';
import { ServiceCategory } from '../types/service';
import { SERVICE_GROUPS } from '../constants/serviceGroups';

/**
 * Creates a groupBy function for categorizing service categories.
 * This function groups services based on their slug matching entries in SERVICE_GROUPS.
 *
 * @param t - The translation function from i18next
 * @returns A function that takes a ServiceCategory and returns its translated group name
 */
export const createServiceGroupBy = (t: TFunction): ((item: ServiceCategory) => string) => {
  return (item: ServiceCategory) => {
    for (const [groupKey, slugs] of Object.entries(SERVICE_GROUPS)) {
      if (slugs.includes(item.slug)) {
        return t(`serviceGroups.${groupKey}`, { ns: 'common' });
      }
    }
    return t('serviceGroups.autres', { ns: 'common' });
  };
};
